import * as React from 'react';
import * as UserActions from '../../actions/users';
import { RouteComponentProps } from 'react-router';
import { toast } from 'react-toastify'
import * as request from 'superagent';
import * as Modal from 'react-modal';

export namespace ForgotPassword {
    export interface Props extends RouteComponentProps<void> {
    }

    export interface State {
        showModal: boolean
    }
}

const customStyles = {
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '-50%',
      transform             : 'translate(-50%, -50%)'
    }
  };


export default class ForgotPassword extends React.Component<ForgotPassword.Props, ForgotPassword.State> {
    username: HTMLInputElement;
    email: HTMLInputElement;
    
    constructor(props: ForgotPassword.Props) {
        super(props);

        this.state = {
            showModal: false
        }

        this.sendRequest = this.sendRequest.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({showModal: true});
    }
  
    closeModal() {
        this.setState({showModal: false});
    }

    sendRequest(e: any) {
        e.preventDefault();

        const username = this.username.value,
                email  = this.email.value;
        
        if(!username && !email)  
            toast.error("Sinun täytyy antaa joko käyttäjänimi tai sähköpostiosoite.")
        else { 
            request
                .post('user/forgotPassword')        
                .set('Content-Type', 'application/json')
                .send({username, email})
                .then((response) => {
                    toast.success('Pyyntö onnistui. Saat pian sähköpostiisi ohjeet salasanan palautukseen.');
                })   
                .catch((err) => {
                    toast.error('Käyttäjätunnusta tai sähköpostiosoitetta ei löytynyt.');
                })         
        }
    } 

    render() {
        return  (
            <div>
                <div className="col-12">
                    <a className="centered"
                        href="#"
                        onClick={this.openModal}>
                        <b>Unohditko salasanasi?</b>
                    </a>
				</div>

                <Modal
                    isOpen={this.state.showModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <form className="form-group" id="am_forgotpassword" onSubmit={this.sendRequest}>
                        <input ref={(input) => this.username = input} className="col-12 form-control mb-1" placeholder="Käyttäjätunnus"/>
                        <input ref={(input) => this.email = input} className="col-12 form-control mb-1"  placeholder="Sähköpostiosoite"/>
                        <button type="submit" className={"col-12 btn form-control am_green-button am_shadow mb-1"}>LÄHETÄ</button>
                        <button type="button" onClick={this.closeModal} className={"col-12 btn form-control am_red-button am_shadow mb-1"}>PERUUTA</button>
                    </form>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/Common/ForgotPassword.tsx